module.exports = __webpack_public_path__ + "static/media/blackFile.31e41d85.svg";